import { createApiRef } from '@backstage/core-plugin-api';
import { getOrCreateGlobalSingleton } from '@backstage/version-bridge';

const scaffolderApiRef = getOrCreateGlobalSingleton(
  "scaffolder:scaffolder-api-ref",
  () => createApiRef({
    id: "plugin.scaffolder.service"
  })
);

export { scaffolderApiRef };
//# sourceMappingURL=ref.esm.js.map
